module.exports = __webpack_public_path__ + "static/media/partner-story-ad3.0f5b6439.jpg";